import SendMultiplePinReport from "../../Component/EPin/SendMultiplePin";
const SendMultiplePinPage = () => {
  return (
    <div className='page-body'>
      <SendMultiplePinReport />
    </div>
  )
}

export default SendMultiplePinPage